<template>
  <div>
    <div class="modal fade" id="addCollectionModal" tabIndex="-1" aria-labelledby="addCollectionModalTittle"
         aria-hidden="true">
      <div class="modal-dialog  modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="createProjectModalTitle">Add a collection</h5>
            <button type="button" id="closeAddCollectionModalButton" class="close" data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col">
                <label>Collection to add ?</label>
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="collection name"
                         aria-label="CollectionString"
                         aria-describedby="basic-addon1" v-model="collectionString"></div>
              </div>

            </div>
            <hr>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Abort</button>
              <button type="button" class="btn btn-primary" v-on:click="onAddCollectionSubmit()">Add collection</button>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="row row-cols-1"
         :class="{ 'row-cols-lg-2': [2].includes(columns), 'row-cols-lg-3': [3].includes(columns), 'row-cols-xxl-2': [2].includes(columns), 'row-cols-xxl-3': [3].includes(columns) }">


      <div class="p-2 projectCard" v-for="project in projects" :key="project.id" v-bind:id="'projectCard-'+project.id">
        <div class="card rounded-3 shadow-sm rounded col-12">

          <div class="card-header pr-1 pl-1 bg-transparent d-inline-block text-truncate border-light">

            <div class="row align-items-center">
            <span data-bs-toggle="tooltip" data-bs-placement="top" :title="project.name"
                  class="col-11 text-left text-truncate text-dark">{{ project.name }}</span>
              <a title="Delete" class="col close float-right" v-on:click="$emit('delete-project', project.id )"></a>
            </div>

          </div>


          <div class="card-body pb-1">
            <p v-if="project.collections.length > 0" class="card-title text-left"><strong>Collections: </strong>
            <div v-else>
              <p class="card-title text-left"><strong>No collections </strong></p>
            </div>

            <div class="card-text text-left mb-2" :style="{'min-height': '24px'}">
              <div v-for="collection in project.collections" v-bind:key="collection" class="float-left mr-2">
                <span class="row mx-auto" :style=" {'--color': '#cccccc'}" :class="{'bg-whitesmoke': false}">
                  <span class="border border-600 rounded my-auto row mr-0 ml-0 pr-1 pl-1">
                    <span class="icon my-auto mr-0 ml-0" :class="{}" :style="{'color': '#1abc9c', 'height': 20, 'width': 2, 'font-size': 12}" :title="'title'"></span>
                    <span class="my-auto mr-1" :style="{'font-size': 12}">{{ collection }}</span>
                    <span href="#" class="my-auto icon icon-delete clickable" v-on:click="$emit('delete-collection', signedUser, project.id, collection  )"></span>
                  </span>
                </span>
              </div>
            </div>
            <div class="float-right d-flex flex-row mt-1 mb-1">
              <button type="button" class="btn btn-sm btn-primary rounded "
                      v-on:click="$emit('select-project',project )"
                      :class="{'disabled': false}" :title="'Details'">Details
              </button>

              <a :ref="'linkOpenCollectionsEditor-'+project.id" class="d-none" data-toggle="modal"
                 data-target="#addCollectionModal"></a>


              <div class="position-relative" :id="'dropdownBoundaryContainer-'+project.id">
                <a :id="'projectActionLauncher-'+project.id"
                   class="position-relative my-auto mb-4 mt-3 ml-2 btn btn-sm btn-secondary rounded"
                   :data-boundary="'dropdownBoundaryContainer-'+project.id" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false" :style="{'height': '30px'}">
                  <span class="mr-2 d-none d-md-inline-block">Edit</span>
                  <span class=" icon icon-More-dots mr-0 " :style="{'transform': 'rotate(90deg)'}"></span>
                </a>

                <ul class="dropdown-menu dropdown-menu-right mt-0 mb-1" role="menu"
                    :aria-labelledby="'addCollectionLauncher-'+project.id">
                  <div class="px-1 py-1">
                    <div :title="'add collection'">
                      <li href="#" class="dropdown-item btn btn-sm" :active="false" :class="{'disabled': false}"
                          v-on:click="openCollectionsEditor(project.id)">add collection
                      </li>
                    </div>
                  </div>
                </ul>

              </div>

            </div>
          </div>
          <div class="card-footer">
            <p v-if="project.creationDate" class="card-text text-left text-muted"><small>Created the
              {{ project.creationDate.slice(0, 10) }}</small></p>
          </div>

        </div>
      </div>
    </div>

  </div>


</template>
<script>
import Flip from '../../utils/Flip';
import ProjectApi from '../../generatedApiClient/api/endpoints/ProjectApi';

let projectApiInstance = new ProjectApi();

export default {
  name: "CardsProjects",
  props: ["projects", "columns"],
  components: {},
  data() {
    return {
      addCollectionModalProjectId: undefined,
      collectionString: undefined,
      flip: new Flip(),
    }
  },
  computed: {
    signedUser: function () {
      return (this.$store.state.identityIdentified !== undefined) ? this.$store.state.identityIdentified.email : undefined;
    },
  },
  updated: function () {
    if (this.updateType === "tables") {
      let newProjects = Array.from(document.querySelectorAll('.projectCard'));
      this.flip.play(newProjects);
      this.flip = new Flip();
    }
  },
  watch: {
    projects(val, oldVal) {
      console.log(`[watch] [projects] update ${(val && oldVal) ? '' : 'with missing value'}`);
      let existingProjects = Array.from(document.querySelectorAll('.projectCard'));
      this.flip.read(existingProjects);
      this.updateType = "tables";
    },
  },
  methods: {
    updateAuthJwtToken: function (apiInstance) {
      if (apiInstance && apiInstance.apiClient && apiInstance.apiClient.authentications && apiInstance.apiClient.authentications['AuthJWT']) {
        apiInstance.apiClient.authentications['AuthJWT'].accessToken = this.$store.state.identityIdentified.token;
      }
    },
    openCollectionsEditor: function (projectId) {
      this.addCollectionModalProjectId = projectId;
      const links = this.$refs['linkOpenCollectionsEditor-' + projectId];
      console.log(links.length);
      if ((links) && (links.length > 0)) {
        links[0].click();
      }

    },
    onAddCollectionSubmit: function () {
      if ((this.collectionString) && (this.addCollectionModalProjectId)) {
        console.log('[onAddCollectionSubmit]')
        this.updateAuthJwtToken(projectApiInstance);
        projectApiInstance.createCollection(this.signedUser, this.addCollectionModalProjectId, {name: this.collectionString})
            .then(createCollectionResp => {
              console.log("[onAddCollectionSubmit] [API] [createCollection] [OK]");
              //this.$store.commit('selectProject', {id: createProjectResp.id, name: createProjectResp.name});
              this.emitCollectionAdded(createCollectionResp);
              //let cb = document.getElementById('closeAddCollectionModalButton');

              document.getElementById('closeAddCollectionModalButton').click();
            })
            .catch(createCollectionError => {
              console.log("[onAddCollectionSubmit] [API] [createCollection] [ERROR]", createCollectionError);
              this.emitCollectionAddedError(createCollectionError);
              document.getElementById('closeModalButton').click();
            })


      }
    },
    emitCollectionAdded: function () {
      this.$emit('collection-added', {});
    },
    emitCollectionAddedError: function () {
      this.$emit('collection-added-error', {});
    },


  }
};
</script>

<style scoped>


.clickable {
  cursor: pointer
}

</style>